import Errors from '@/shared/error/errors';
import ApiService from '@/shared/services/api.service';

// action types
export const GET_ORG_RESPONSIBILITIES = 'getOrgResponsibilities';
export const DELETE_RESPONSIBILITY = 'removeResponsibility';

// mutation types
export const FETCH_SUCCESS = 'fetchSuccess';
export const SET_CURRENT_PAGE = 'setCurrentPage';
export const SET_FILTERS = 'setFilters';

const state = {
    rows: [],
    total: 0,
    storeFilters: {},
    currentPage: 1,
};

const getters = {
    rows: (state) => state.rows || [],
    total: (state) => state.total,
    filters: (state) => state.storeFilters,
    currentPage: (state) => state.currentPage,
};

const actions = {
    [GET_ORG_RESPONSIBILITIES](context, {payload, id}) {
        context.commit('shared/activateLoading', 'admin/getOrgResponsibilities', { root: true });
        payload.query = `organisation_id eq ${id} and ` + payload.query;
        const filters = { params: { ...payload, pagination: true } };
        return new Promise((resolve, reject) => {
            ApiService.query('/organisation-responsibilities', filters)
                .then(({ data }) => {
                    context.commit(FETCH_SUCCESS, {
                        rows: data.data,
                        total: data.pagination.total,
                    });
                    resolve(data);
                })
                .catch((error) => {
                    Errors.handle(error);
                    reject();
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'admin/getOrgResponsibilities', { root: true });
                })
        });
    },
    [DELETE_RESPONSIBILITY](context, id) {
        context.commit('shared/activateLoading', 'admin/deleteResponsibility', { root: true });
        return new Promise((resolve) => {
            ApiService.delete(`organisation-responsibilities/${id}`)
            .then(() => {
                resolve();
            })
            .catch((error) => {
                Errors.handle(error);
            })
            .finally(() => {
                context.commit('shared/deactivateLoading', 'admin/deleteResponsibility', { root: true });
            })
        });
    }
};

const mutations = {
    [FETCH_SUCCESS](state, payload) {
        state.rows = payload.rows;
        state.total = payload.total;
    },
    [SET_CURRENT_PAGE](state, page) {
        state.currentPage = page;
    },
    [SET_FILTERS](state, { key, value }) {
        state.storeFilters[key] = value;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
